export const DEFAULT_MAX_DURATION = 300
export const DEFAULT_MIN_DURATION = 5
export const DEFAULT_VIDEO_AD_HEIGHT = 480
export const DEFAULT_VIDEO_AD_WIDTH = 640
export const DEFAULT_VIDEO_AD_SIZE = [
  DEFAULT_VIDEO_AD_WIDTH,
  DEFAULT_VIDEO_AD_HEIGHT
]

export const SECONDARY_VIDEO_AD_HEIGHT = 360
export const SECONDARY_VIDEO_AD_WIDTH = 480
export const SECONDARY_VIDEO_AD_SIZE = [
  SECONDARY_VIDEO_AD_WIDTH,
  SECONDARY_VIDEO_AD_HEIGHT
]

export const CACHE_URL = 'https://prebid.adnxs.com/pbc/v1/cache'
export const OPENX_URL = 'mediavine-d.openx.net'

export const CPM_TOFIXED_LIMIT = 2
export const CPM_TEST_VALUE = 20.0

export const FAILSAFE_WAIT = 3000
export const BID_REQUEST_WAIT = 1500

export const TEST_BID_FLOOR = 0.01

export const GAM_ADS_TAG_URL =
  'https://securepubads.g.doubleclick.net/gampad/live/ads'
export const GAM_SAMPLE_TAG_URL =
  'https://securepubads.g.doubleclick.net/gampad/live/ads?sz=640x480&iu=/124319096/external/ad_rule_samples&ciu_szs=300x250&ad_rule=1&npa=0&impl=s&gdfp_req=1&env=vp&output=vmap&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ar%3Dpreonly&cmsid=496&vid=short_onecue&correlator='
export const GAM_SKIPPABLE_TAG_URL =
  'https://securepubads.g.doubleclick.net/gampad/live/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator='
